export enum AstroSignEnum {
  BELIER = 'Bélier',
  TAUREAU = 'Taureau',
  GEMEAUX = 'Gémeaux',
  CANCER = 'Cancer',
  LION = 'Lion',
  VIERGE = 'Vierge',
  BALANCE = 'Balance',
  SCORPION = 'Scorpion',
  SAGITTAIRE = 'Sagittaire',
  CAPRICORNE = 'Capricorne',
  VERSEAU = 'Verseau',
  POISSONS = 'Poissons',
}

export const getAstroSignEnumValues = (): string[] => Object.values(AstroSignEnum);
